import { Box, styled } from '@mui/material';

export const OrdersShowResponseBoxStyled = styled(Box)({
  backgroundColor: '#fff',
  border: '1px dashed rgba(0,0,0,0.23)',
  borderRadius: '4px',
  position: 'relative',
});
